(() => {
  if (customElements.get('haccp-quick-set')) return;
  class HaccpQuickSet extends HTMLElement {
    connectedCallback() {
      this.colors = this.querySelector('.haccp-set__colors');
      this.form = this.querySelector('form');
      this.button = this.querySelector('button[type="submit"]');
      this.colors?.addEventListener('change', this.update);
      this.form?.addEventListener('submit', this.add);
      this.update();
    }
    disconnectedCallback() {
      this.colors?.removeEventListener('change', this.update);
      this.form?.removeEventListener('submit', this.add);
    }
    update = () => {
      const option = this.colors?.querySelector('input:checked');
      if (!option) return;
      this.querySelector('[data-set-color-name]').textContent = option.getAttribute('aria-label');
      this.querySelectorAll('[data-set-price]').forEach(el => { el.hidden = el.dataset.setPrice !== option.value; });
      if (option.dataset.images) {
        const images = JSON.parse(option.dataset.images);
        this.querySelectorAll('.haccp-set__images img').forEach(img => {
          const index = Number(img.dataset.setImageIndex);
          if (!images[index]) return;
          img.src = images[index].url;
          img.removeAttribute('srcset');
          img.alt = images[index].alt || '';
        });
      }
      this.button.disabled = !option.dataset.items;
    };
    add = async event => {
      event.preventDefault();
      if (this.button.disabled) return;
      const items = JSON.parse(this.colors.querySelector('input:checked').dataset.items);
      const cart = document.querySelector('cart-drawer');
      const status = this.querySelector('[role="status"]');
      this.button.disabled = true;
      this.button.setAttribute('aria-busy', 'true');
      status.textContent = '';
      let added = false;
      try {
        const payload = {items};
        if (cart) {
          payload.sections = cart.getSectionsToRender().map(section => section.id);
          payload.sections_url = location.pathname;
          cart.setActiveElement(this.closest('dialog') ? document.querySelector('.haccp-dual__action[href="#haccp-starter-set"]') : this.button);
        }
        const response = await fetch(window.routes.cart_add_url, {
          method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'}, body: JSON.stringify(payload)
        });
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(result.description || 'Die Kombination konnte nicht hinzugefügt werden. Bitte prüfen Sie die Verfügbarkeit.');
        added = true;
        this.closest('dialog')?.close();
        status.textContent = 'Alle Bestandteile wurden in den Warenkorb gelegt.';
        if (typeof publish === 'function') publish(PUB_SUB_EVENTS.cartUpdate, {source: 'haccp-quick-set', cartData: result});
        if (cart && result.sections && Object.values(result.sections).every(Boolean)) {
          cart.classList.remove('is-empty');
          cart.renderContents(result);
        } else { location.assign(window.routes.cart_url); }
      } catch (error) {
        if (added) { location.assign(window.routes.cart_url); return; }
        status.textContent = error.message || 'Bitte versuchen Sie es erneut.';
      } finally {
        this.button.disabled = false;
        this.button.removeAttribute('aria-busy');
      }
    };
  }
  customElements.define('haccp-quick-set', HaccpQuickSet);
  document.addEventListener('click', event => {
    const trigger = event.target.closest('a[href="#haccp-starter-set"]');
    if (trigger) {
      const dialog = document.getElementById('haccp-starter-set')?.closest('dialog');
      if (dialog) { event.preventDefault(); dialog.showModal(); }
    }
    const close = event.target.closest('[data-set-dialog-close]');
    if (close) close.closest('dialog')?.close();
  });
  document.addEventListener('change', event => {
    if (!event.target.matches('[data-haccp-stem]')) return;
    const total = event.target.closest('.haccp-stem-choice').querySelector('[data-haccp-stem-total]');
    if (total) total.hidden = !event.target.checked;
  });
})();
